module.exports = __webpack_public_path__ + "static/media/factory_icon.87782c48.svg";